import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-s-alert';

import Snoozes from 'api/resources/snoozes';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import CloseIcon from 'icons/Close';
import SimpleButton from 'styled/Buttons/SimpleButton';
import ListItemRow from 'styled/ListItemRow';

class SnoozesActiveItem extends React.PureComponent {
  state = {
    loading: false,
  }

  handleDeactivateClick = async () => {
    this.setState({ loading: true });

    try {
      const response = await Snoozes.patch({
        snoozeId: this.props.id,
        body: {
          data: {
            type: 'snooze',
            attributes: { is_active: false },
          },
        },
       });

      const snoozes = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);
      this.props.onDeactivate(snoozes);

      Alert.success('Снуз успешно деактивирован');
      this.setState({ loading: false });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <ListItemRow>
        {this.props.name}

        <SimpleButton
          type="button"
          onClick={this.handleDeactivateClick}
          style={{ marginLeft: 'auto', marginRight: '15px' }}
          disabled={this.state.loading}
        >
          <CloseIcon size={10} />
        </SimpleButton>
      </ListItemRow>
    );
  }
}

SnoozesActiveItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onDeactivate: PropTypes.func,
};

SnoozesActiveItem.defaultProps = {
  onDeactivate: () => {},
};

export default SnoozesActiveItem;
